import { cloneElement, type ReactElement } from 'react';

import { I, type IconProps } from '@/components/ri/icons';

export interface PWAUpdateBannerProps {
  open: boolean;
  onRefresh: () => void;
}

export function PWAUpdateBanner({ open, onRefresh }: PWAUpdateBannerProps) {
  if (!open) return null;
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: 12,
        right: 12,
        // Sit just below the 56px app header so the prompt is in view without covering navigation.
        top: 'calc(68px + env(safe-area-inset-top, 0px))',
        zIndex: 420,
        background: 'var(--accent-soft)',
        color: 'var(--accent-text)',
        borderRadius: 10,
        padding: '10px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        border: '1px solid var(--accent)',
        boxShadow: 'var(--shadow-md)',
      }}
    >
      {cloneElement(I.bolt as ReactElement<IconProps>, { size: 16 })}
      <span style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>New version ready</span>
      <button
        onClick={onRefresh}
        style={{
          background: 'var(--accent)',
          border: 0,
          color: 'var(--text-on-accent)',
          fontSize: 12,
          fontWeight: 600,
          padding: '5px 12px',
          borderRadius: 6,
          cursor: 'pointer',
        }}
      >
        Refresh
      </button>
    </div>
  );
}
